import React from 'react';

const HtmlContent = ({ htmlString }) => {
    return (
        <div dangerouslySetInnerHTML={{ __html: htmlString }} />
    );
};

export default HtmlContent;
